"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trim = (str, char) => {
    return str.replace(new RegExp("^[" + char + "]+|[" + char + "]+$", "g"), "");
};



//////////////////
// WEBPACK FOOTER
// ./~/device-detector-js/dist/utils/trim.js
// module id = 1413
// module chunks = 14 15